<template>
  <div class="col-12">
    <div class="search-padd">
      <div class="col-xs-12 override-padding">
        <div class="crm_admin_heading tasklist_heading_1 text-align-left">Task List</div>
        <div class="crm_admin_heading tasklist_heading_2 text-align-center"># of Users</div>
        <!-- <div class="crm_admin_heading tasklist_heading_2 text-align-center"># of Mentors</div> -->
        <div class="crm_admin_heading tasklist_heading_2 text-align-center">Total Tasks</div>
        <div class="crm_admin_heading tasklist_heading_3 text-align-center">Completed Tasks</div>
        <div class="crm_admin_heading tasklist_heading_4 text-align-center">Average Rating</div>
        <div class="crm_admin_heading tasklist_heading_5 text-align-center"># of Repetitions</div>
      </div>
      <div style="clear: both;"></div>
      <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
      <div v-for="(account_tasklist, index) in account_tasklists">
        <div class="crm_admin_field_lists tasklist_heading_1 text-align-left">
          <div class="search-padd">
            {{account_tasklist.name}}
          </div>
        </div>
        <div class="crm_admin_field_lists tasklist_heading_2 text-align-center">
          <div class="search-padd">
          {{account_tasklist.menteecnt}}
          </div>
        </div>
        <!--
        <div class="crm_admin_field_lists tasklist_heading_2 text-align-center">
          <div class="search-padd">
          &nbsp;
          </div>
        </div>
        -->
        <div class="crm_admin_field_lists tasklist_heading_2 text-align-center">
          <div class="search-padd">
          {{account_tasklist.taskcnt}}
          </div>
        </div>
        <div class="crm_admin_field_lists tasklist_heading_3 text-align-center">
          <div class="search-padd">{{account_tasklist.no_of_completed_tasks}}</div>
        </div>
        <div class="crm_admin_field_lists tasklist_heading_4 text-align-center">
          <div class="search-padd">{{account_tasklist.average_score}}</div>
        </div>
        <div class="crm_admin_field_lists tasklist_heading_5 text-align-center">
          <div class="search-padd">{{ account_tasklist.no_of_repetitions }}</div>
        </div>
        <div style="clear: both;"></div>
        <div class="tasklist-item-seperator"></div>
      </div>
    </div>
    <div class="col-12 override-padding" v-if="account_tasklists.length == 0">
      No task lists found
    </div>
    <div style="clear: both;" class="margin-bottom-10"></div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
      props: ['accountId'],
      data() {
        return {
          account_tasklists: [],
          loading: false
        }
      },
      methods: {
        getTaskListStatisticsData: function() {
          axios.get('/account_tasklists_statistics/' + this.accountId, {

          })
          .then(response => {
            this.loading = false;
            this.account_tasklists = response.data;
          })
          .catch(error => {

          });
        },
      },
      created: function () {
        this.loading = true;
        this.getTaskListStatisticsData();
      },
    }
</script>


<style>
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.tasklist_heading_1 {
  width: 40%;
}
.tasklist_heading_2 {
  width: 10%;
}
.tasklist_heading_3 {
  width: 15%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_tasklists_tab.vue